import { RootState } from "integrations/redux"
import { PanelNames } from "panels/constants"
import { UserProfileContext, WorkspaceConfirmationContext } from "./types"

export const selectOverlayComponentName = (state: RootState) => state.overlay.contentComponentName

export const selectOverlayComponentType = (state: RootState) => state.overlay.contentComponentType

export const selectNextComponentFromQueue = (state: RootState) =>
    state.overlay.componentQueue[0] ?? undefined

export const selectBackgroundClose = (state: RootState): boolean => state.overlay.backgroundClose

export const selectOverlayState = (state: RootState) => state[PanelNames.Overlay]

export const selectOverlayType = (state: RootState) => state.overlay.type

export const selectWorkspaceConfirmationModalContext = (
    state: RootState
): WorkspaceConfirmationContext => state.overlay.workspaceConfirmationContext!

export const selectUserProfileModalContext = (state: RootState): UserProfileContext =>
    state.overlay.userProfileContext!
